import type { TOC } from '@ember/component/template-only';
import { eq } from 'ember-truth-helpers';
import Card from 'garaje/components/ui/card';
import arrayToSentence from 'garaje/helpers/array-to-sentence';
import type Entry from 'garaje/models/entry';
import type Invite from 'garaje/models/invite';

interface ApprovalNeedsReviewSignature {
  Args: {
    invite?: Invite;
    entry?: Entry;
    contactedNames: string[];
  };
}

export default <template>
  <Card class="border-carbon-20 mb-8">
    <div class="text-sm" data-test-approval-pending>
      <p class="mb-0">
        {{#if @entry}}
          This visitor requires approval for entry.
        {{else if @invite}}
          {{if
            @invite.preregistrationComplete
            "This invite requires approval."
            "This invite requires approval to send."
          }}
        {{/if}}
      </p>
      {{#if @contactedNames}}
        <p class="mb-0">
          {{arrayToSentence @contactedNames}}
          {{if (eq @contactedNames.length 1) "has" "have"}}
          been notified.
        </p>
      {{/if}}
    </div>
  </Card>
</template> satisfies TOC<ApprovalNeedsReviewSignature>;
